// O localizador e opcional porque a ausencia dele E o modo delivery: exigi-lo aqui deixa o
// cliente de entrega preso no checkout.
//
// Com `slug` (cliente entrou por `/loja/{slug}`), a rota segue pelo slug: montar com os ids
// faria a URL voltar a mostrar os uuids no primeiro clique.
export function cardapioRota(
  empresaId: string,
  estabelecimentoId: string,
  localizadorId?: string,
  slug?: string,
): string[] | null {
  if (slug) {
    return slugRota(slug, '', localizadorId);
  }
  if (!empresaId || !estabelecimentoId) {
    return null;
  }
  const rota = ['/apps/e-commerce/shop', empresaId, estabelecimentoId];
  if (localizadorId) {
    rota.push(localizadorId);
  }
  return rota;
}

// A vitrine passou a ter botao proprio de sacola porque a navbar (unico caminho para o
// checkout ate aqui) fica escondida na loja. Vai para a rota com contexto, e nao para
// /checkout solto, senao recarregar a pagina perde empresa e estabelecimento.
export function checkoutRota(
  empresaId: string,
  estabelecimentoId: string,
  localizadorId?: string,
  slug?: string,
): string[] | null {
  if (slug) {
    return slugRota(slug, 'sacola', localizadorId);
  }
  if (!empresaId || !estabelecimentoId) {
    return null;
  }
  const rota = ['/apps/e-commerce/confirma', empresaId, estabelecimentoId];
  if (localizadorId) {
    rota.push(localizadorId);
  }
  return rota;
}

export function pedidosRota(
  empresaId: string,
  estabelecimentoId: string,
  localizadorId?: string,
  slug?: string,
): string[] | null {
  if (slug) {
    return slugRota(slug, 'pedidos', localizadorId);
  }
  return lojaRota('pedidos', empresaId, estabelecimentoId, localizadorId);
}

export function perfilRota(
  empresaId: string,
  estabelecimentoId: string,
  localizadorId?: string,
  slug?: string,
): string[] | null {
  if (slug) {
    return slugRota(slug, 'perfil', localizadorId);
  }
  return lojaRota('perfil', empresaId, estabelecimentoId, localizadorId);
}

// `/loja/{slug}[/{localizadorid}][/{tela}]` - o localizador vem antes da tela para que o
// QR de mesa seja so `/loja/{slug}/{localizadorid}`.
export function slugRota(slug: string, tela: string, localizadorId?: string): string[] {
  const rota = ['/loja', slug];
  if (localizadorId) {
    rota.push(localizadorId);
  }
  if (tela) {
    rota.push(tela);
  }
  return rota;
}

function lojaRota(
  tela: string,
  empresaId: string,
  estabelecimentoId: string,
  localizadorId?: string,
): string[] | null {
  if (!empresaId || !estabelecimentoId) {
    return null;
  }
  const rota = [`/apps/e-commerce/${tela}`, empresaId, estabelecimentoId];
  if (localizadorId) {
    rota.push(localizadorId);
  }
  return rota;
}
